module.exports = __webpack_public_path__ + "img/icon-check-green.6e7bd561.svg";